import { ChevronLeft, ChevronRight } from 'lucide-react';
import type { ReactElement } from 'react';
import { cn } from '@/shared/ui';

interface HeroCursorProps {
  /** 히어로 안에서의 마우스 위치(px). */
  readonly x: number;
  readonly y: number;
  /** 지금 누르면 넘어갈 쪽 — 화면 왼쪽 절반이면 이전, 오른쪽 절반이면 다음. 그쪽 화살표만 진하게. */
  readonly side: 'prev' | 'next';
  readonly selectedIndex: number;
  readonly count: number;
}

/**
 * 히어로 위에서 마우스를 따라다니는 둥근 넘김 표시 — ‹ 현재/전체 ›.
 * 장식이라 보조기기는 건너뛴다(같은 조작이 아래쪽 이전·다음 버튼에 있다). 클릭은 아래 판이 받는다.
 */
export const HeroCursor = ({ x, y, side, selectedIndex, count }: HeroCursorProps): ReactElement => (
  <div
    aria-hidden
    className="pointer-events-none absolute top-0 left-0 z-30 flex size-24 items-center justify-center gap-1.5 rounded-full bg-background/45 text-sm text-foreground tabular-nums"
    style={{ transform: `translate3d(${x}px, ${y}px, 0) translate(-50%, -50%)` }}
  >
    <ChevronLeft className={cn('size-4', side === 'prev' ? 'opacity-100' : 'opacity-35')} />
    <span>
      {selectedIndex + 1}/{count}
    </span>
    <ChevronRight className={cn('size-4', side === 'next' ? 'opacity-100' : 'opacity-35')} />
  </div>
);
